module.exports = __webpack_public_path__ + "img/newTOP.db4e9428.jpg";